import { Component, EventEmitter, Output } from '@angular/core';
import { MyOrganizationFacade, SharedFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { ActionButtonComponent } from '../action-button/action-button.component';

@Component({
  selector: 'piqet-angular-invoice-data-modal',
  templateUrl: './invoice-data-modal.component.html',
  styleUrls: ['./invoice-data-modal.component.css'],
})
export class InvoiceDataModalComponent {
  processColumnDef: any;
  modalLabel: any;
  loginLogsHistory: any = [];
  isMaximize = false;
  searchData: any = '';
  isSearchInputPosition = true;
  event: any;
  sortColumnState: any;
  loginLogsHistoryPayload: any;
  userId: any;
  userName: any;
  gridName = 'Invoice Modal';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
  };
  constructor(
    private modal: CustomModalService,
    private sharedFacade: SharedFacade,
    public myOrganizationFacade: MyOrganizationFacade
  ) {
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.loginLogsHistory.push(this.modal?.modalService?.config?.initialState?.['invoiceData']);
  }

  onClose() {
    this.modal.close();
  }
}
